export type WeaponKind = "hitscan" | "melee";

export type WeaponDef = {
  name: string;
  kind: WeaponKind;
  damage: number;          // body-shot damage; headshots are damage × HEADSHOT_MULTIPLIER (hitscan only)
  cooldownMs: number;
  range: number;
  magazineSize: number;    // ignored for melee (set to 0)
  reloadMs: number;        // ignored for melee
};

export type ClassDef = {
  id: string;
  name: string;
  description: string;
  primary: WeaponDef;
  melee: WeaponDef;
  speedMultiplier: number;
  hp: number;
};

/** Headshots multiply hitscan body damage. Melee never headshots. */
export const HEADSHOT_MULTIPLIER = 2;
/** Top of the player AABB used as the head zone (meters above feet). */
export const HEAD_ZONE_MIN = 1.45;

export const CLASSES: Record<string, ClassDef> = {
  trooper: {
    id: "trooper",
    name: "Trooper",
    description: "All-rounder. 4-shot kill body, 2-shot head.",
    primary: { name: "Rifle",   kind: "hitscan", damage: 25, cooldownMs: 150,  range: 80,  magazineSize: 30, reloadMs: 2000 },
    melee:   { name: "Knife",   kind: "melee",   damage: 50, cooldownMs: 500,  range: 2.5, magazineSize: 0,  reloadMs: 0 },
    speedMultiplier: 1.0,
    hp: 100,
  },
  scout: {
    id: "scout",
    name: "Scout",
    description: "Fast and fragile. High RoF SMG.",
    primary: { name: "SMG",     kind: "hitscan", damage: 12, cooldownMs: 80,   range: 50,  magazineSize: 25, reloadMs: 1800 },
    melee:   { name: "Knife",   kind: "melee",   damage: 50, cooldownMs: 500,  range: 2.5, magazineSize: 0,  reloadMs: 0 },
    speedMultiplier: 1.25,
    hp: 75,
  },
  sniper: {
    id: "sniper",
    name: "Sniper",
    description: "Two body or one headshot to kill.",
    primary: { name: "Bolt",    kind: "hitscan", damage: 50, cooldownMs: 1100, range: 200, magazineSize: 5,  reloadMs: 2500 },
    melee:   { name: "Hatchet", kind: "melee",   damage: 60, cooldownMs: 600,  range: 2.5, magazineSize: 0,  reloadMs: 0 },
    speedMultiplier: 0.85,
    hp: 100,
  },
  brawler: {
    id: "brawler",
    name: "Brawler",
    description: "Tanky. Two body or one headshot close.",
    primary: { name: "Shotgun", kind: "hitscan", damage: 60, cooldownMs: 700,  range: 12,  magazineSize: 6,  reloadMs: 2500 },
    melee:   { name: "Bat",     kind: "melee",   damage: 80, cooldownMs: 700,  range: 3.0, magazineSize: 0,  reloadMs: 0 },
    speedMultiplier: 1.1,
    hp: 140,
  },
};

export const DEFAULT_CLASS_ID = "trooper";

export function getClass(id: string | undefined): ClassDef {
  if (id && CLASSES[id]) return CLASSES[id];
  return CLASSES[DEFAULT_CLASS_ID];
}
